module.exports = __webpack_public_path__ + "img/placholder-profile-pic.742f75d7.jpg";